import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { default as dayjs } from 'dayjs'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Y from 'yup'

import { useGetMutateCall } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { createYupSchema } from '../../lib/createYUPSchema'
import invalid from '../../assets/images/invalid.svg'

const animatedComponents = makeAnimated()

export const ClassActivityModal = ({
  isLocalEnvironment,
  authDetails,
  setOpenClassActivity,
  modSchema,
  defaultData,
  roomVal,
  autoRefresh,
  dates,
  setSelectedApplData,
}) => {
  const getCallMutation = useGetMutateCall()
  const createCallMutation = useCreateCall()
  const [activeTab, setActiveTab] = React.useState(0)
  const [multiValue, setMultiValue] = React.useState([])

  const validations = [
    {
      name: 'activityDetailLabel',
      validationType: 'string',
      validations: [{ type: 'required', params: ['Label is required!'] }],
    },
  ]
  const validation = Y.object().shape({
    ...validations.reduce(createYupSchema, {}),
  })

  const validateAdd = Y.object().shape({
    ...modSchema.rowForm.create.buildValidation.reduce(createYupSchema, {}),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(validation),
  })

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(validateAdd),
  })

  const onCreate = async (data) => {
    data['lastUpdatedByUserId'] = authDetails.session.userId

    const details = {
      lastUpdatedByUserId: authDetails.session.userId,
    }

    const selectedChildren = []
    if (multiValue.length > 0) {
      multiValue.map((id) => {
        if (id.value === 'select_all') {
          options.map(
            (elem) =>
              elem.value !== 'select_all' &&
              selectedChildren.push({
                activityDetailType: data.activityDetailType,
                activityDetailLabel: data.activityDetailLabel,
                activityDetailDescription: data.activityDetailDescription,
                activityDetailNotes: data.activityDetailNotes,
                activityId: elem.value.activities[0].activityId,
              }),
          )
        } else {
          selectedChildren.push({
            ...details,
            activityDetailType: data.activityDetailType,
            activityDetailLabel: data.activityDetailLabel,
            activityDetailDescription: data.activityDetailDescription,
            activityDetailNotes: data.activityDetailNotes,
            activityId: id.value.activities[0].activityId,
          })
        }
      })
    }
    const formData = {
      activityDetailType: data.activityDetailType,
      activityDetailLabel: data.activityDetailLabel,
      activityDetailDescription: data.activityDetailDescription,
      activityDetailNotes: data.activityDetailNotes,
      activityDetail: selectedChildren,
    }

    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'activityDetail',
        data: formData,
        messageTitle: 'Activities',
        message: 'Activity Uploaded!',
        isMultipart: true,
        isDynamic: true,
        params: '',
      })
      .then(async () => {
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'attendance',
            params:
              '&checkInDateTime=' +
              dayjs.utc(dates === null ? new Date() : dates).format('YYYY-MM-DD HH:mm:ss') +
              `&classRoomId=${roomVal}`,
            doPolling: autoRefresh,
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
          })
          .catch(() => {})
        setActiveTab(0)
      })
  }

  const onUpload = async (data) => {
    let formData = new FormData()

    data['lastUpdatedByUserId'] = authDetails.session.userId

    const details = {
      lastUpdatedByUserId: authDetails.session.userId,
      ...data,
    }

    const selectedChildren = []
    if (multiValue.length > 0) {
      multiValue.map((id) => {
        if (id.value === 'select_all') {
          options.map(
            (elem) =>
              elem.value !== 'select_all' &&
              selectedChildren.push({
                ...details,
                activityId: elem.value.activities[0].activityId,
                applicationId: elem.value.attendanceRegistration.applicationId,
              }),
          )
        } else {
          selectedChildren.push({
            ...details,
            activityId: id.value.activities[0].activityId,
            applicationId: id.value.attendanceRegistration.applicationId,
          })
        }
      })
    }

    formData.append('activityDetailType', 'image')
    formData.append('file', data.activityDetailDescription[0])
    formData.append('activityDetailLabel', data.activityDetailLabel)
    formData.append('activityDetailNotes', 'Image')
    formData.append('activityDetail', JSON.stringify(selectedChildren))

    await createCallMutation
      .mutateAsync({
        url: `${isLocalEnvironment}/upload?endPoint=activityDetail/image`,
        apiEndpoint: modSchema.rowForm.update.formAPI,
        parentAPI: modSchema.rowForm.update.parentAPI,
        data: formData,
        headers: {
          tokenSource: 'passport',
          Authorization: `Bearer ${authDetails.authentication.tokenObject}`,
        },
        messageTitle: 'Activities',
        message: 'Activity Uploaded!',
        isMultipart: true,
        isDynamic: true,
        params: '',
      })
      .then(async () => {
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'attendance',
            params:
              '&checkInDateTime=' +
              dayjs.utc(dates === null ? new Date() : dates).format('YYYY-MM-DD HH:mm:ss') +
              `&classRoomId=${roomVal}`,
            doPolling: autoRefresh,
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
          })
          .catch(() => {})
        setActiveTab(0)
      })
  }

  const proForm = [
    {
      name: 'Add Activity',
    },
    {
      name: 'Upload File',
    },
  ]

  let options
  options =
    defaultData.map((f) => {
      return { value: f, label: f.attendanceRegistration?.studentName }
    }) || []

  if (options.length > 0) {
    options.splice(0, 0, { label: 'All Children', value: 'select_all' })
  }

  const handleMultiChange = (option) => {
    setMultiValue(option)
  }

  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Activity Details
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenClassActivity(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-card">
              <div className="trtui-card-body trtui-p-2">
                <div className="trtui-card-header">
                  <ul
                    className="trtui-nav trtui-nav-tabs-custom trtui-rounded trtui-card-header-tabs trtui-border-bottom-0"
                    role="tablist"
                  >
                    {proForm.length > 0 &&
                      proForm.map((form, formIndex) => (
                        <li className="trtui-nav-item" role="presentation" key={formIndex}>
                          <span
                            className={`trtui-nav-link trtui-cursor-pointer ${
                              activeTab === formIndex ? 'trtui-active' : ''
                            }`}
                            data-bs-toggle="tab"
                            role="tab"
                            onClick={() => setActiveTab(formIndex)}
                          >
                            {form.name}
                          </span>
                        </li>
                      ))}
                  </ul>
                </div>
                <div className="trtui-tab-content">
                  <div
                    className={`trtui-tab-pane ${activeTab === 0 ? 'trtui-active' : ''}`}
                    role="tabpanel"
                  >
                    <form onSubmit={handleSubmit2(onCreate)} id="addActivity" data-testid="formAdd">
                      <div className="trtui-row trtui-g-2">
                        <div className="trtui-mb-12">
                          <label htmlFor="emailInput" className="trtui-form-label">
                            Select Children
                          </label>
                          <Select
                            name="id"
                            options={options}
                            components={animatedComponents}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={handleMultiChange}
                          />
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-control-label">Type</label>
                          <div className="trtui-input-group trtui-has-validation">
                            <input
                              type="text"
                              placeholder="Label"
                              className={`trtui-form-control ${errors2['activityDetailType'] && 'trtui-is-invalid'}`}
                              style={{
                                color: '#000000',
                                paddingRight: 'calc(1.5em + 1rem)',
                                backgroundImage:
                                  errors['activityDetailType'] && `url("${invalid}")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                              }}
                              {...register2('activityDetailType')}
                            />
                            {errors2['activityDetailType'] && (
                              <div className="trtui-invalid-feedback">
                                {errors2['activityDetailType'].message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-control-label">Label</label>
                          <div className="trtui-input-group trtui-has-validation">
                            <input
                              type="text"
                              placeholder="Label"
                              className={`trtui-form-control ${errors2['activityDetailLabel'] && 'trtui-is-invalid'}`}
                              {...register2('activityDetailLabel')}
                            />
                            {errors2['activityDetailLabel'] && (
                              <div className="trtui-invalid-feedback">
                                {errors2['activityDetailLabel'].message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-label">Description</label>
                          <textarea
                            type="text"
                            placeholder="Description"
                            {...register2('activityDetailDescription')}
                            className={`trtui-form-control ${errors2['activityDetailDescription'] && 'trtui-is-invalid'}`}
                          ></textarea>
                          {errors2['activityDetailDescription'] && (
                            <div className="trtui-invalid-feedback">
                              {errors2['activityDetailDescription'].message}
                            </div>
                          )}
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-label">Notes</label>
                          <textarea
                            type="text"
                            placeholder="Notes"
                            {...register2('activityDetailNotes')}
                            className={`trtui-form-control ${errors2['activityDetailNotes'] && 'trtui-is-invalid'}`}
                            style={{
                              color: '#000000',
                              paddingRight: 'calc(1.5em + 1rem)',
                              backgroundImage:
                                errors2['activityDetailNotes'] && `url("${invalid}")`,
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                              backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                            }}
                          ></textarea>
                          {errors2['activityDetailNotes'] && (
                            <div className="trtui-invalid-feedback">
                              {errors2['activityDetailNotes'].message}
                            </div>
                          )}
                        </div>
                        <div className="trtui-col-12">
                          <button
                            className={`trtui-btn trtui-btn-primary trtui-btn-sm`}
                            type="submit"
                            disabled={createCallMutation.isLoading}
                          >
                            {createCallMutation.isLoading ? (
                              <span className="trtui-d-flex trtui-align-items-center">
                                <span className="trtui-flex-grow-1 trtui-me-2">Adding...</span>
                                <span
                                  className="trtui-spinner-border trtui-flex-shrink-0"
                                  role="status"
                                >
                                  <span className="trtui-visually-hidden">Adding...</span>
                                </span>
                              </span>
                            ) : (
                              'Add'
                            )}
                          </button>{' '}
                          <button
                            className={`trtui-btn trtui-btn-light trtui-btn-sm`}
                            type="submit"
                            disabled={createCallMutation.isLoading}
                            onClick={() => setOpenClassActivity(false)}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div
                    className={`trtui-tab-pane ${activeTab === 1 ? 'trtui-active' : ''}`}
                    role="tabpanel"
                  >
                    <form onSubmit={handleSubmit(onUpload)} data-testid="formAdd">
                      <div className="trtui-row trtui-g-2">
                        <div className="trtui-mb-12">
                          <label htmlFor="emailInput" className="trtui-form-label">
                            Select Children
                          </label>
                          <Select
                            name="id"
                            options={options}
                            components={animatedComponents}
                            isMulti
                            closeMenuOnSelect={false}
                            onChange={handleMultiChange}
                          />
                        </div>
                        <div
                          className={`trtui-col-md-6 trtui-has-validation`}
                          style={{ display: 'none' }}
                        >
                          <label className="trtui-form-control-label">Image</label>
                          <div className="trtui-input-group trtui-has-validation">
                            <input
                              type="text"
                              className={`trtui-form-control ${errors['activityDetailType'] && 'trtui-is-invalid'}`}
                              style={{
                                color: '#000000',
                                paddingRight: 'calc(1.5em + 1rem)',
                                backgroundImage:
                                  errors['activityDetailType'] && `url("${invalid}")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                              }}
                              {...register('activityDetailType')}
                            />
                            {errors['activityDetailType'] && (
                              <div className="trtui-invalid-feedback">
                                {errors['activityDetailType'].message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-control-label">Description</label>
                          <div className="trtui-input-group trtui-has-validation">
                            <input
                              type="text"
                              placeholder="Description"
                              className={`trtui-form-control ${errors['activityDetailLabel'] && 'trtui-is-invalid'}`}
                              style={{
                                color: '#000000',
                                paddingRight: 'calc(1.5em + 1rem)',
                                backgroundImage:
                                  errors['activityDetailLabel'] && `url("${invalid}")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                              }}
                              {...register('activityDetailLabel')}
                            />
                            {errors['activityDetailLabel'] && (
                              <div className="trtui-invalid-feedback">
                                {errors['activityDetailLabel'].message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={`trtui-col-md-6 trtui-has-validation`}>
                          <label className="trtui-form-control-label">Image</label>
                          <div className="trtui-input-group trtui-has-validation">
                            <input
                              type="file"
                              className={`trtui-form-control ${errors['activityDetailDescription'] && 'trtui-is-invalid'}`}
                              style={{
                                color: '#000000',
                                paddingRight: 'calc(1.5em + 1rem)',
                                backgroundImage:
                                  errors['activityDetailDescription'] && `url("${invalid}")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                              }}
                              {...register('activityDetailDescription')}
                            />
                            {errors['activityDetailDescription'] && (
                              <div className="trtui-invalid-feedback">
                                {errors['activityDetailDescription'].message}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="trtui-col-12">
                          <button
                            className={`trtui-btn trtui-btn-primary trtui-btn-sm`}
                            type="submit"
                            disabled={createCallMutation.isLoading}
                          >
                            {createCallMutation.isLoading ? (
                              <span className="trtui-d-flex trtui-align-items-center">
                                <span className="trtui-flex-grow-1 trtui-me-2">Uploading...</span>
                                <span
                                  className="trtui-spinner-border trtui-flex-shrink-0"
                                  role="status"
                                >
                                  <span className="trtui-visually-hidden">Uploading...</span>
                                </span>
                              </span>
                            ) : (
                              'Upload'
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ClassActivityModal.propTypes = {
  isLocalEnvironment: PropTypes.string,
  authDetails: PropTypes.object,
  childFormData: PropTypes.object,
  setOpenClassActivity: PropTypes.func,
  modSchema: PropTypes.object,
  defaultData: PropTypes.object,
  roomVal: PropTypes.string,
  autoRefresh: PropTypes.bool,
  dates: PropTypes.string,
  setSelectedApplData: PropTypes.func,
}
